module.exports = __webpack_public_path__ + "img/BT_language_NO.6f36fbdb.svg";